export enum WeightUnit {
  g = 0,
  kg = 1,
  t = 2,
  mg = 3,
}

export interface WeightDto {
  value: number;
  unit: WeightUnit;
}
